import { Component, OnInit, Input, ViewChild, ElementRef, Renderer } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../api/services/auth.service';
import { UserService } from '../../../api/services/user.service';
import { ProjectService } from '../../../api/services/project.services';
import { ToastrService } from 'ngx-toastr';
import { RoleRequest } from '../../../api/models/role-assignment-map';
import { TagModel } from 'ngx-chips/core/accessor';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-download-copy',
  templateUrl: './download-copy.component.html',
  styleUrls: ['./download-copy.component.scss']
})
export class DownloadCopyComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal,
    private authService: AuthService,
    private userService: UserService,
    private projectService: ProjectService,
    private renderer: Renderer,
    private toastr: ToastrService
  ) { }

  invalidEmailErrorMessage : boolean = false;
  emailList = [];
  orgId: string;
  format = 'PDF';
  blob: any;
  @Input() importExport = false;
  loading: boolean = false;
  sending: boolean = false;
  excelBtnDisabled: boolean = false;
  csvBtnDisabled: boolean = false;
  includeTaxAndPdg: boolean = true;
  pdfBtnDisabled: boolean = false;
  @Input() worksheetId: string;
  @ViewChild('downloadAnchor') anchor: ElementRef;
  roleRequest: RoleRequest;
  canViewTaxAndPDGButton = false;
  salesTaxNeedToBeDisplayedInQuote: boolean;
  emailWorksheet() {
    const userIdList = this.emailList.filter(user => this.validateUUID(user.value)).map(user => user.value);
    const userEmailList = this.emailList.filter(user => !this.validateUUID(user.value)).map(user => user.value);
    if(userEmailList.length>=1){
      this.invalidEmailErrorMessage = userEmailList.some(email => !this.validateEmail(email));
      if (!this.invalidEmailErrorMessage) {
        this.sending = true;
        this.projectService.exportWorksheetByEmail(this.worksheetId, this.format, userIdList, userEmailList).subscribe(() => {
          this.sending = false;
          this.activeModal.close();
          this.onEmailSuccess();
        }, error => {
          this.sending = false;
          this.onError(error.error.message);
        });
      }
    }else{
      this.onError('Email address is required!!!');
    }
  }

  downloadPdf() {
    if (this.canViewTaxAndPDGButton) {
      this.salesTaxNeedToBeDisplayedInQuote = this.includeTaxAndPdg;
    } else {
      this.salesTaxNeedToBeDisplayedInQuote = true;
    }
    this.loading = true;
    this.pdfBtnDisabled = true;
    this.projectService.getWorksheetPdf(this.worksheetId, this.salesTaxNeedToBeDisplayedInQuote).subscribe(url => {
      this.anchor.nativeElement.href = url;
      this.renderer.invokeElementMethod(
        this.anchor.nativeElement, 'click', []);
        this.loading = false;
        this.pdfBtnDisabled = false;
    }, error => {
      const message = error.error.message;
      if (message && message != null){
        this.onError(message);
      }else{
        this.onError('Error downloading the file!!!');
      }
      this.loading = false;
      this.pdfBtnDisabled = false;
    });
  }

  downloadXls() {
    this.loading = true;
    this.excelBtnDisabled = true;
    this.projectService.getWorksheetXls(this.worksheetId, this.authService.getUserId()).subscribe((resp) => {
      const fileName = resp.headers.get('filename') ? resp.headers.get('filename') : 'ATC_PO_REQ_UPLOAD_' + this.worksheetId;
      const data = resp.body;
      this.blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var downloadUrl = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName + '.xlsx';
      link.click();
      this.loading = false;
      this.excelBtnDisabled = false;
    }, error => {
      this.onError("Error downloading the file!!!");
      this.loading = false;
      this.excelBtnDisabled = false;
    });
  }

  downloadCSV() {
    this.loading = true;
    this.csvBtnDisabled = true;
    this.projectService.getWorksheetCSV(this.worksheetId, this.authService.getUserId()).subscribe((resp) => {
      const fileName = resp.headers.get('filename') ? resp.headers.get('filename') : 'ATC_PO_REQ_UPLOAD_' + this.worksheetId;
      const data = resp.body;
      this.blob = new Blob([data], { type: 'text/csv' });
      var downloadUrl = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName + '.csv';
      link.click();
      this.loading = false;
      this.csvBtnDisabled = false;
    }, error => {
      this.onError("Error downloading the file!!!");
      this.loading = false;
      this.csvBtnDisabled = false;
    });
  }

  private onEmailSuccess() {
    this.toastr.success('Email sent!!!', 'Succcess!', {
      timeOut: 3000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onError(msg: string) {
    this.toastr.error(msg, 'Error!', {
      timeOut: 3000,
      positionClass: 'toast-bottom-right'
    });
  }

  autocompleteUsers = (text: string) => {
    return this.userService.findUserByOrganizationIdAndText(this.orgId, text)
      .pipe(map(data => data.map(user => [`${user['First Name']} ${user['Last Name']}`, user['User ID']])));
  }
  
  validateEmail(email: string) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateUUID(id: string) {
    const re = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
    return re.test(String(id).toLowerCase());
  }

  ngOnInit() {
    this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
      this.orgId = user['Organization ID'];
    });
    this.loading =true;
    this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
      this.canViewTaxAndPDGButton = roles.getRoleMap('ADMIN_TESSCO');
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-worksheet/download-copy/download-copy.component.ts